/* eslint-disable */
import moment from 'moment';
import { FILTER_PREV_DATE_RANGE_SELECTED } from '../Filters.types';
/**
 * Action to update the previous date range based on the `numberOfDays` and the `startDate` in the filters
 * @returns {ActionCreator<FromPayload<null, ActionMeta, FILTER_PREV_DATE_RANGE_SELECTED>>} The created `Action`
 */
const filtersPrevDateRangeSelected = (startDate) => ({ fromPayload }) => {
  const params = { debounce: true };
  if (
    moment()
      .subtract(2, `months`)
      .startOf(`month`)
      .isAfter(moment(startDate))
  ) {
    params.startDate = moment()
      .subtract(2, `months`)
      .startOf(`month`)
      .toDate();
  }
  return fromPayload(null, { ...params }, FILTER_PREV_DATE_RANGE_SELECTED);
};

export default filtersPrevDateRangeSelected;
